import React from 'react';
import SkeletonTable from './v4/DataTable/SkeletonTable';

const Table = ({data, metadata, loading, id, totals}) => {
    return (
        <table id={id} className='table table-bordered table-striped'>
            <thead>
                <tr>
                    {metadata.map((col, index) => (
                        col.visible !== false && (
                            <th key={index}>{col.label}</th>
                        )
                    ))}
                </tr>
            </thead>
            <tbody>
                {loading ? (
                    <SkeletonTable columns={metadata.length+1} />
                            ) : (
                    data?.map((row, index) => (
                        <tr key={index}>
                            {metadata.map((col, index) => (
                            col.visible !== false && (
                                col.type === 'money2' ? (
                                    <td key={index} style={{textAlign: 'right', paddingRight: '20px'}}>{parseFloat(row[col.source]).toFixed(2)}</td>
                                ) : (
                                    <td key={index} style={{textAlign: 'center', paddingRight: '20px'}}>{row[col.source]}</td>
                                )
                            )
                        ))}
                    </tr>
                )))}
            </tbody>
            {totals && (
                <tfoot>
                    <tr>
                        {totals.map((total, index) => (
                            <td key={index} style={{
                                textAlign: total.align || 'center',
                                paddingRight: total.align === 'right' ? '20px' : '0'
                            }}>
                                {total.value}
                            </td>
                        ))}
                    </tr>
                </tfoot>
            )}
        </table>
    )
}

export default Table; 